import { render } from "./LegacyAuthentication.vue?vue&type=template&id=5f6349d4"
import script from "./LegacyAuthentication.vue?vue&type=script&lang=js"
export * from "./LegacyAuthentication.vue?vue&type=script&lang=js"
script.render = render

export default script